import { Lock, X } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { IconButtonWithTooltip } from "@/payroll/ai-script/icon-button-with-tooltip";

interface AccessDeniedStateProps {
  onClose: () => void;
}

export const AccessDeniedState = ({ onClose }: AccessDeniedStateProps) => (
  <Stack fullWidth align="stretch" className="h-full min-h-0" gap="none">
    <div className="shrink-0 border-b border-stroke-tertiary bg-card/80 px-4 py-3 backdrop-blur-sm">
      <Stack direction="row" align="center" justify="between" fullWidth>
        <Typography variant="subtitleW2">Payroll Chat</Typography>
        <IconButtonWithTooltip label="Close" onClick={onClose}>
          <X className="h-5 w-5" />
        </IconButtonWithTooltip>
      </Stack>
    </div>
    <Stack
      align="center"
      justify="center"
      gap="sm"
      className="flex-1 px-8 text-center"
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-bg-secondary text-tertiary-text">
        <Lock className="h-5 w-5" />
      </div>
      <Typography variant="subtitleW3">Payroll chat isn't available</Typography>
      <Typography variant="bodyW3" textColor="secondary">
        You don't have access to this pay period's workbook. Ask an admin to
        grant you access if you think this is a mistake.
      </Typography>
    </Stack>
  </Stack>
);
